import { Anchor, Box, Heading, Image, Paragraph, Text } from "grommet";
// import teamData from "../teamData.json";
import CenteredColumn from "../components/CenteredColumn";
import { PortableText } from "@portabletext/react";

const ProviderPage = ({ provider }) => {

  return (
    <Box>
      <CenteredColumn pad={{ top: "medium" }} columnWidth="large">
        <Box align="center">
          <Heading level={1} margin={{ bottom: "none" }}>
            {provider.fullName}
          </Heading>
          <Text>
            <i>{provider.title}</i>
          </Text>

          <Box height="medium">
            <Image
              fit="contain"
              src={provider.profilePictureUrl}
              alt={provider.name}
            />
          </Box>
          <Box pad={{ vertical: "medium" }}>
            <Text>
              <PortableText
                value={provider.body}
                // components={/* optional object of custom components to use */}
              />
            </Text>
            {/* {provider.body} */}
            {/* <Text>{data.fullBio}</Text> */}
          </Box>
          <Box align="center" gap="xsmall" pad={{ bottom: "medium" }}>
            <Text>{provider.email}</Text>
            <Text>{provider.phone}</Text>
            {provider.psychologyTodayUrl && (
              <Anchor href={provider.psychologyTodayUrl} target="_blank">
                Psychology Today
              </Anchor>
            )}
          </Box>
        </Box>
      </CenteredColumn>
    </Box>
  );
};
export default ProviderPage;
